import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-video-preview',
  standalone: true,
  imports: [],
  templateUrl: './video-preview.html',
  styleUrl: './video-preview.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoPreview {
  video = input<string>();
}
